import React from 'react';

const CheckinSidePanel = ({ formData, sites = [], departments = [], locations = [], onSiteChange, onLocationChange, onDepartmentChange, onNotesChange }) => {
  return (
    <div className="checkin-side-panel" style={{
      background: 'white',
      padding: '16px',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600 }}>Location Changes (Optional)</h3>
      
      <div className="form-group">
        <label htmlFor="site">Site</label>
        <select
          id="site"
          name="site"
          value={formData.site || ''}
          onChange={(e) => onSiteChange && onSiteChange(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px'
          }}
        >
          <option value="">Select Site (Optional)</option>
          {sites.map(site => (
            <option key={site.id || site._id} value={site.id || site._id}>
              {site.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="location">Location</label>
        <select
          id="location"
          name="location"
          value={formData.location || ''}
          onChange={(e) => onLocationChange && onLocationChange(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px'
          }}
        >
          <option value="">Select Location (Optional)</option>
          {locations.map(loc => (
            <option key={loc.id || loc._id} value={loc.name}>
              {loc.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="department">Department</label>
        <select
          id="department"
          name="department"
          value={formData.department || ''}
          onChange={(e) => onDepartmentChange && onDepartmentChange(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px'
          }}
        >
          <option value="">Select Department (Optional)</option>
          {departments.map(dept => (
            <option key={dept.id || dept._id} value={dept.id || dept._id}>
              {dept.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="notes">Check-In Notes</label>
        <textarea
          id="notes"
          name="notes"
          value={formData.notes || ''}
          onChange={(e) => {
            if (onNotesChange) {
              onNotesChange(e.target.value);
            }
          }}
          rows="4"
          placeholder="Enter any notes or instructions..."
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px',
            fontFamily: 'inherit',
            resize: 'vertical'
          }}
        />
      </div>
    </div>
  );
};

export default CheckinSidePanel;
